// import React from 'react';

// const RateList = () => {
//   // Data from Image 1
//   const aepsCharges = [
//     { slab: '100 - 499', charge: '0.00' },
//     { slab: '500 - 999', charge: '0.50' },
//     { slab: '1000 - 1499', charge: '1.50' },
//     { slab: '1500 - 1999', charge: '3.50' },
//     { slab: '2000 - 2499', charge: '5.00' },
//     { slab: '2500 - 2999', charge: '6.00' },
//     { slab: '3000 - 8999', charge: '10.00' },
//     { slab: '9000 - 10000', charge: '12.00' },
//   ];

//   // Data from Image 2 & User Text
//   const mobileDthCharges = [
//     { provider: 'Airtel', commission: '1%' },
//     { provider: 'Jio', commission: '0.5%' },
//     { provider: 'Vodafone Idea', commission: '1.5%' },
//     { provider: 'BSNL', commission: '2%' },
//     { provider: 'All DTH (Airtel, Dish TV, Sun, Tata Sky, Videocon)', commission: '2%' },
//   ];

//   // Data from User Text
//   const settlementCharges = [
//     { slab: '100 - 1000', rt: '₹7 flat'},
//     { slab: '1001 - 1999', rt: '0.70%' },
//     { slab: '2000 - 25000', rt: '0.50%'},
//   ];

//   return (
//     <div className="min-h-screen bg-gray-50 p-4 md:p-8 font-sans">
//       <div className="max-w-7xl mx-auto bg-white shadow-lg rounded-xl overflow-hidden border border-gray-100">
        
//         {/* Header */}
//         <div className="bg-[#12345A] text-white py-6 px-8">
//           <h1 className="text-3xl font-bold text-center tracking-wide">
//              Rate List & Commissions
//           </h1>
//         </div>

//         {/* Content Grid */}
//         <div className="p-8 grid grid-cols-1 lg:grid-cols-2 gap-10">
          
//           {/* Section 1: AePS Charges */}
//           <div className="space-y-4">
//             <h2 className="text-2xl font-semibold text-[#12345A] border-b-2 border-[#12345A] pb-2">
//               AePS Agent Charges
//             </h2>
//             <div className="overflow-x-auto rounded-lg border border-gray-200">
//               <table className="w-full text-left border-collapse">
//                 <thead>
//                   <tr className="bg-[#12345A] text-white">
//                     <th className="py-3 px-4 font-medium">AePS Slabs (₹)</th>
//                     <th className="py-3 px-4 font-medium text-right">Retailer Commission (₹)</th>
//                   </tr>
//                 </thead>
//                 <tbody className="divide-y divide-gray-200">
//                   {aepsCharges.map((item, index) => (
//                     <tr key={index} className="hover:bg-blue-50 transition-colors">
//                       <td className="py-3 px-4 text-gray-700">{item.slab}</td>
//                       <td className="py-3 px-4 text-right font-medium text-gray-900">{item.charge}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//           <div className="space-y-10">
//             {/* Section 2: Mobile & DTH */}
//             <div className="space-y-4">
//               <h2 className="text-2xl font-semibold text-[#12345A] border-b-2 border-[#12345A] pb-2">
//                 Mobile & DTH Commissions
//               </h2>
//               <div className="overflow-x-auto rounded-lg border border-gray-200">
//                 <table className="w-full text-left border-collapse">
//                   <thead>
//                     <tr className="bg-[#12345A] text-white">
//                       <th className="py-3 px-4 font-medium">Service Provider</th>
//                       <th className="py-3 px-4 font-medium text-right">Retailer Commission</th>
//                     </tr>
//                   </thead>
//                   <tbody className="divide-y divide-gray-200">
//                     {mobileDthCharges.map((item, index) => (
//                       <tr key={index} className="hover:bg-blue-50 transition-colors">
//                         <td className="py-3 px-4 text-gray-700">{item.provider}</td>
//                         <td className="py-3 px-4 text-right font-medium text-gray-900">{item.commission}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>

//             {/* Section 3: Settlement Charges */}
//             <div className="space-y-4">
//               <h2 className="text-2xl font-semibold text-[#12345A] border-b-2 border-[#12345A] pb-2">
//                Aeps Settlement Charges
//               </h2>
//               <div className="overflow-x-auto rounded-lg border border-gray-200">
//                 <table className="w-full text-left border-collapse">
//                   <thead>
//                     <tr className="bg-[#12345A] text-white">
//                       <th className="py-3 px-4 font-medium">Slab (₹)</th>
//                       <th className="py-3 px-4 font-medium text-right">Retailers Charges</th>
//                     </tr>
//                   </thead>
//                   <tbody className="divide-y divide-gray-200">
//                     {settlementCharges.map((item, index) => (
//                       <tr key={index} className="hover:bg-blue-50 transition-colors">
//                         <td className="py-3 px-4 text-gray-700 whitespace-nowrap">{item.slab}</td>
//                         <td className="py-3 px-4 text-right font-medium text-gray-900">{item.rt}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// };

// export default RateList;


// import React from "react";
// import { 
//   Percent, 
//   Smartphone, 
//   Building2, 
//   ArrowRightLeft, 
//   Sparkles, 
//   CheckCircle2,
//   Layers,
//   IndianRupee
// } from "lucide-react";

// const RateList = () => {
//   // Data from Image 1
//   const aepsCharges = [
//     { slab: "₹100 - ₹499", charge: "0.00" },
//     { slab: "₹500 - ₹999", charge: "0.50" },
//     { slab: "₹1,000 - ₹1,499", charge: "1.50" },
//     { slab: "₹1,500 - ₹1,999", charge: "3.50" },
//     { slab: "₹2,000 - ₹2,499", charge: "5.00" },
//     { slab: "₹2,500 - ₹2,999", charge: "6.00" },
//     { slab: "₹3,000 - ₹8,999", charge: "10.00" },
//     { slab: "₹9,000 - ₹10,000", charge: "12.00" },
//   ];

//   // Data from Image 2 & User Text
//   const mobileDthCharges = [
//     { provider: "Airtel", commission: "1.00%" },
//     { provider: "Jio", commission: "0.50%" },
//     { provider: "Vodafone Idea (Vi)", commission: "1.50%" },
//     { provider: "BSNL", commission: "2.00%" },
//     { provider: "All DTH (Airtel, Dish TV, Sun, Tata Play, Videocon)", commission: "2.00%" },
//   ];

//   // Data from User Text
//   // const settlementCharges = [
//   //   { slab: "₹100 - ₹1,000", rt: "₹7.00 Flat" },
//   //   { slab: "₹1,001 - ₹1,999", rt: "0.70%" },
//   //   { slab: "₹2,000 - ₹25,000", rt: "0.50%" },
//   // ];
//   const settlementCharges = [
//     { slab: "₹100 - ₹1,000", rt: "₹8.00 Flat" },
//     { slab: "₹1,001 - ₹2,999", rt: "0.80%" },
//     { slab: "₹3,000 - ₹25,000", rt: "0.50%" },
//   ];

//   return (
//     <div className="min-h-screen bg-[#F8FAFC] p-4 sm:p-6 lg:p-8 space-y-6">
      
//       {/* ================= PAGE HEADER ================= */}
//       <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
//         <div>
//           <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-blue-50 text-blue-700 border border-blue-100 mb-2">
//             <Percent className="w-3.5 h-3.5" />
//             Official Pricing & Agent Commission Matrix
//           </div>
//           <h1 className="text-2xl sm:text-3xl font-extrabold text-slate-800 tracking-tight">
//             Rate List & Commissions
//           </h1>
//           <p className="text-xs sm:text-sm text-slate-500 font-medium mt-0.5">
//             Transparent breakdown of agent margins, recharge cashbacks, and settlement slab fees
//           </p>
//         </div>
//       </div>

//       {/* ================= CONTENT GRID ================= */}
//       <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
        
//         {/* LEFT COLUMN: AEPS Agent Charges (Span 6) */}
//         <div className="lg:col-span-6 bg-white rounded-3xl p-6 border border-slate-200/80 shadow-xs space-y-4">
//           <div className="flex items-center justify-between pb-3 border-b border-slate-100">
//             <div className="flex items-center gap-2.5">
//               <div className="p-2.5 rounded-2xl bg-blue-50 text-blue-600 border border-blue-100/60">
//                 <Building2 className="w-4 h-4" />
//               </div>
//               <div>
//                 <h2 className="text-base font-bold text-slate-800 leading-none">
//                   AePS Agent Commissions
//                 </h2>
//                 <p className="text-[11px] text-slate-400 font-medium mt-1">
//                   Cash withdrawal commission per transaction slab
//                 </p>
//               </div>
//             </div>
//             <span className="text-[11px] font-bold px-2.5 py-1 bg-emerald-50 text-emerald-700 border border-emerald-100 rounded-full">
//               Live Slabs
//             </span>
//           </div>

//           <div className="overflow-hidden rounded-2xl border border-slate-200/70">
//             <table className="w-full text-left border-collapse text-xs">
//               <thead>
//                 <tr className="bg-slate-900 text-white font-semibold">
//                   <th className="py-3 px-4">Transaction Slab Range</th>
//                   <th className="py-3 px-4 text-right">Retailer Margin (₹)</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-slate-100 font-medium text-slate-700">
//                 {aepsCharges.map((item, index) => (
//                   <tr key={index} className="hover:bg-slate-50/80 transition-colors">
//                     <td className="py-3 px-4 font-mono font-semibold text-slate-800">
//                       {item.slab}
//                     </td>
//                     <td className="py-3 px-4 text-right font-mono font-bold text-emerald-700 text-sm">
//                       ₹{item.charge}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* RIGHT COLUMN: Mobile/DTH + Settlement (Span 6) */}
//         <div className="lg:col-span-6 space-y-6">
          
//           {/* Section 2: Mobile & DTH Commissions */}
//           <div className="bg-white rounded-3xl p-6 border border-slate-200/80 shadow-xs space-y-4">
//             <div className="flex items-center justify-between pb-3 border-b border-slate-100">
//               <div className="flex items-center gap-2.5">
//                 <div className="p-2.5 rounded-2xl bg-amber-50 text-amber-700 border border-amber-100/60">
//                   <Smartphone className="w-4 h-4" />
//                 </div>
//                 <div>
//                   <h2 className="text-base font-bold text-slate-800 leading-none">
//                     Mobile & DTH Commissions
//                   </h2>
//                   <p className="text-[11px] text-slate-400 font-medium mt-1">
//                     Instant cashback on prepaid recharges & DTH packs
//                   </p>
//                 </div>
//               </div>
//               <span className="text-[11px] font-bold px-2.5 py-1 bg-blue-50 text-blue-700 border border-blue-100 rounded-full">
//                 Prepaid & DTH
//               </span>
//             </div>

//             <div className="overflow-hidden rounded-2xl border border-slate-200/70">
//               <table className="w-full text-left border-collapse text-xs">
//                 <thead>
//                   <tr className="bg-slate-900 text-white font-semibold">
//                     <th className="py-3 px-4">Operator / Service Provider</th>
//                     <th className="py-3 px-4 text-right">Commission Rate</th>
//                   </tr>
//                 </thead>
//                 <tbody className="divide-y divide-slate-100 font-medium text-slate-700">
//                   {mobileDthCharges.map((item, index) => (
//                     <tr key={index} className="hover:bg-slate-50/80 transition-colors">
//                       <td className="py-3 px-4 font-semibold text-slate-800">
//                         {item.provider}
//                       </td>
//                       <td className="py-3 px-4 text-right font-mono font-bold text-emerald-700 text-sm">
//                         {item.commission}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//           {/* Section 3: AePS Settlement Charges */}
//           <div className="bg-white rounded-3xl p-6 border border-slate-200/80 shadow-xs space-y-4">
//             <div className="flex items-center justify-between pb-3 border-b border-slate-100">
//               <div className="flex items-center gap-2.5">
//                 <div className="p-2.5 rounded-2xl bg-rose-50 text-rose-600 border border-rose-100/60">
//                   <ArrowRightLeft className="w-4 h-4" />
//                 </div>
//                 <div>
//                   <h2 className="text-base font-bold text-slate-800 leading-none">
//                     AePS Settlement Charges
//                   </h2>
//                   <p className="text-[11px] text-slate-400 font-medium mt-1">
//                     Standard bank charges to primary settlement accounts
//                   </p>
//                 </div>
//               </div>
//               <span className="text-[11px] font-bold px-2.5 py-1 bg-rose-50 text-rose-700 border border-rose-100 rounded-full">
//                 Settlement
//               </span>
//             </div>

//             <div className="overflow-hidden rounded-2xl border border-slate-200/70">
//               <table className="w-full text-left border-collapse text-xs">
//                 <thead>
//                   <tr className="bg-slate-900 text-white font-semibold">
//                     <th className="py-3 px-4">Settlement Amount Slab</th>
//                     <th className="py-3 px-4 text-right">Retailer Fee / Charge</th>
//                   </tr>
//                 </thead>
//                 <tbody className="divide-y divide-slate-100 font-medium text-slate-700">
//                   {settlementCharges.map((item, index) => (
//                     <tr key={index} className="hover:bg-slate-50/80 transition-colors">
//                       <td className="py-3 px-4 font-mono font-semibold text-slate-800">
//                         {item.slab}
//                       </td>
//                       <td className="py-3 px-4 text-right font-mono font-bold text-rose-700 text-sm">
//                         {item.rt}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//         </div>

//       </div>

//     </div>
//   );
// };

// export default RateList;

import React from "react";
import {
  Percent,
  Smartphone,
  Building2,
  ArrowRightLeft,
  Sparkles,
  CheckCircle2,
  Layers,
  IndianRupee,
  Fingerprint,
  Globe2,
  CreditCard,
  Plane,
  Tv,
  Send,
} from "lucide-react";

const RateList = () => {
  // Data from Image 1
  const aepsCharges = [
    { slab: "₹100 - ₹499", charge: "0.00" },
    { slab: "₹500 - ₹999", charge: "0.50" },
    { slab: "₹1,000 - ₹1,499", charge: "1.50" },
    { slab: "₹1,500 - ₹1,999", charge: "3.50" },
    { slab: "₹2,000 - ₹2,499", charge: "5.00" },
    { slab: "₹2,500 - ₹2,999", charge: "6.00" },
    { slab: "₹3,000 - ₹8,999", charge: "10.00" },
    { slab: "₹9,000 - ₹10,000", charge: "12.00" },
  ];

  // Data from Image 2 & User Text
  const mobileDthCharges = [
    { provider: "Airtel", commission: "1.00%" },
    { provider: "Jio", commission: "0.50%" },
    { provider: "Vodafone Idea (Vi)", commission: "1.50%" },
    { provider: "BSNL", commission: "2.00%" },
    { provider: "All DTH (Airtel, Dish TV, Sun, Tata Play, Videocon)", commission: "2.00%" },
  ];

  // Data from User Text
  const settlementCharges = [
    { slab: "₹100 - ₹1,000", rt: "₹8.00 Flat" },
    { slab: "₹1,001 - ₹2,999", rt: "0.80%" },
    { slab: "₹3,000 - ₹25,000", rt: "0.50%" },
  ];

  // Aadhaar Pay
  const aadhaarPayCharges = [
    { slab: "All Transactions", charge: "0.20% + GST" },
  ];

  // Indo Nepal
  const indoNepalCharges = [
    { slab: "₹100 - ₹5,000", charge: "₹150 Flat" },
    { slab: "₹5,001 - ₹50,000", charge: "₹199 Flat" },
  ];

  // CCBP
  const ccbpCharges = [
    { slab: "₹100 - ₹50,000", charge: "₹20 + GST" },
    { slab: "₹50,000+", charge: "₹50 + GST" },
  ];

  // Air Ticket — retailer markup (not zero)
  const airTicketCharges = [
    { slab: "All Bookings", charge: "Retailer Markup" },
  ];

  // STB — updated with below 50k flat charge
  const stbCharges = [
    { slab: "Below ₹50,000", charge: "₹5.90 Flat (incl. GST)" },
    { slab: "Above ₹50,000", charge: "Free" },
  ];

  // DMT
  // const dmtCharges = [
  //   { slab: "₹1,001 - ₹5,000", charge: "0.45%" },
  // ];

  const dmtCharges = [
  { slab: "₹100 - ₹1,000", charge: "₹6.50 Flat" },
  { slab: "₹1,001 - ₹5,000", charge: "0.45%" },
];

  return (
    <div className="min-h-screen bg-[#F8FAFC] p-4 sm:p-6 lg:p-8 space-y-6">
      {/* ================= PAGE HEADER ================= */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-blue-50 text-blue-700 border border-blue-100 mb-2">
            <Percent className="w-3.5 h-3.5" />
            Official Pricing & Agent Commission Matrix
          </div>
          <h1 className="text-2xl sm:text-3xl font-extrabold text-slate-800 tracking-tight">
            Rate List & Commissions
          </h1>
          <p className="text-xs sm:text-sm text-slate-500 font-medium mt-0.5">
            Transparent breakdown of agent margins, recharge cashbacks, and settlement slab fees
          </p>
        </div>
      </div>

      {/* ================= CONTENT GRID ================= */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
        {/* LEFT COLUMN */}
        <div className="lg:col-span-6 space-y-6">
          {/* AEPS Agent Charges */}
          <div className="bg-white rounded-3xl p-6 border border-slate-200/80 shadow-xs space-y-4">
            <div className="flex items-center justify-between pb-3 border-b border-slate-100">
              <div className="flex items-center gap-2.5">
                <div className="p-2.5 rounded-2xl bg-blue-50 text-blue-600 border border-blue-100/60">
                  <Building2 className="w-4 h-4" />
                </div>
                <div>
                  <h2 className="text-base font-bold text-slate-800 leading-none">
                    AePS Agent Commissions
                  </h2>
                  <p className="text-[11px] text-slate-400 font-medium mt-1">
                    Cash withdrawal commission per transaction slab
                  </p>
                </div>
              </div>
              <span className="text-[11px] font-bold px-2.5 py-1 bg-emerald-50 text-emerald-700 border border-emerald-100 rounded-full">
                Live Slabs
              </span>
            </div>
            <div className="overflow-hidden rounded-2xl border border-slate-200/70">
              <table className="w-full text-left border-collapse text-xs">
                <thead>
                  <tr className="bg-slate-900 text-white font-semibold">
                    <th className="py-3 px-4">Transaction Slab Range</th>
                    <th className="py-3 px-4 text-right">Retailer Margin (₹)</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100 font-medium text-slate-700">
                  {aepsCharges.map((item, index) => (
                    <tr key={index} className="hover:bg-slate-50/80 transition-colors">
                      <td className="py-3 px-4 font-mono font-semibold text-slate-800">
                        {item.slab}
                      </td>
                      <td className="py-3 px-4 text-right font-mono font-bold text-emerald-700 text-sm">
                        ₹{item.charge}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Aadhaar Pay */}
          <div className="bg-white rounded-3xl p-6 border border-slate-200/80 shadow-xs space-y-4">
            <div className="flex items-center justify-between pb-3 border-b border-slate-100">
              <div className="flex items-center gap-2.5">
                <div className="p-2.5 rounded-2xl bg-indigo-50 text-indigo-600 border border-indigo-100/60">
                  <Fingerprint className="w-4 h-4" />
                </div>
                <div>
                  <h2 className="text-base font-bold text-slate-800 leading-none">
                    Aadhaar Pay
                  </h2>
                  <p className="text-[11px] text-slate-400 font-medium mt-1">
                    Charges on Aadhaar-enabled biometric payments
                  </p>
                </div>
              </div>
              <span className="text-[11px] font-bold px-2.5 py-1 bg-indigo-50 text-indigo-700 border border-indigo-100 rounded-full">
                UPI / AePS
              </span>
            </div>
            <div className="overflow-hidden rounded-2xl border border-slate-200/70">
              <table className="w-full text-left border-collapse text-xs">
                <thead>
                  <tr className="bg-slate-900 text-white font-semibold">
                    <th className="py-3 px-4">Transaction Type</th>
                    <th className="py-3 px-4 text-right">Charge</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100 font-medium text-slate-700">
                  {aadhaarPayCharges.map((item, index) => (
                    <tr key={index} className="hover:bg-slate-50/80 transition-colors">
                      <td className="py-3 px-4 font-semibold text-slate-800">{item.slab}</td>
                      <td className="py-3 px-4 text-right font-mono font-bold text-indigo-700 text-sm">
                        {item.charge}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Indo Nepal */}
          <div className="bg-white rounded-3xl p-6 border border-slate-200/80 shadow-xs space-y-4">
            <div className="flex items-center justify-between pb-3 border-b border-slate-100">
              <div className="flex items-center gap-2.5">
                <div className="p-2.5 rounded-2xl bg-teal-50 text-teal-600 border border-teal-100/60">
                  <Globe2 className="w-4 h-4" />
                </div>
                <div>
                  <h2 className="text-base font-bold text-slate-800 leading-none">
                    Indo Nepal
                  </h2>
                  <p className="text-[11px] text-slate-400 font-medium mt-1">
                    Flat charges on Indo-Nepal 
                  </p>
                </div>
              </div>
              <span className="text-[11px] font-bold px-2.5 py-1 bg-teal-50 text-teal-700 border border-teal-100 rounded-full">
                Money transfer
              </span>
            </div>
            <div className="overflow-hidden rounded-2xl border border-slate-200/70">
              <table className="w-full text-left border-collapse text-xs">
                <thead>
                  <tr className="bg-slate-900 text-white font-semibold">
                    <th className="py-3 px-4">Amount Slab</th>
                    <th className="py-3 px-4 text-right">Charge</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100 font-medium text-slate-700">
                  {indoNepalCharges.map((item, index) => (
                    <tr key={index} className="hover:bg-slate-50/80 transition-colors">
                      <td className="py-3 px-4 font-mono font-semibold text-slate-800">
                        {item.slab}
                      </td>
                      <td className="py-3 px-4 text-right font-mono font-bold text-teal-700 text-sm">
                        {item.charge}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* CCBP */}
          <div className="bg-white rounded-3xl p-6 border border-slate-200/80 shadow-xs space-y-4">
            <div className="flex items-center justify-between pb-3 border-b border-slate-100">
              <div className="flex items-center gap-2.5">
                <div className="p-2.5 rounded-2xl bg-orange-50 text-orange-600 border border-orange-100/60">
                  <CreditCard className="w-4 h-4" />
                </div>
                <div>
                  <h2 className="text-base font-bold text-slate-800 leading-none">
                    CCBP (Credit Card Bill Payment)
                  </h2>
                  <p className="text-[11px] text-slate-400 font-medium mt-1">
                    Charges on credit card bill payments
                  </p>
                </div>
              </div>
              <span className="text-[11px] font-bold px-2.5 py-1 bg-orange-50 text-orange-700 border border-orange-100 rounded-full">
                Bill Pay
              </span>
            </div>
            <div className="overflow-hidden rounded-2xl border border-slate-200/70">
              <table className="w-full text-left border-collapse text-xs">
                <thead>
                  <tr className="bg-slate-900 text-white font-semibold">
                    <th className="py-3 px-4">Amount Slab</th>
                    <th className="py-3 px-4 text-right">Charge</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100 font-medium text-slate-700">
                  {ccbpCharges.map((item, index) => (
                    <tr key={index} className="hover:bg-slate-50/80 transition-colors">
                      <td className="py-3 px-4 font-mono font-semibold text-slate-800">
                        {item.slab}
                      </td>
                      <td className="py-3 px-4 text-right font-mono font-bold text-orange-700 text-sm">
                        {item.charge}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* RIGHT COLUMN */}
        <div className="lg:col-span-6 space-y-6">
          {/* Mobile & DTH Commissions */}
          <div className="bg-white rounded-3xl p-6 border border-slate-200/80 shadow-xs space-y-4">
            <div className="flex items-center justify-between pb-3 border-b border-slate-100">
              <div className="flex items-center gap-2.5">
                <div className="p-2.5 rounded-2xl bg-amber-50 text-amber-700 border border-amber-100/60">
                  <Smartphone className="w-4 h-4" />
                </div>
                <div>
                  <h2 className="text-base font-bold text-slate-800 leading-none">
                    Mobile & DTH Commissions
                  </h2>
                  <p className="text-[11px] text-slate-400 font-medium mt-1">
                    Instant cashback on prepaid recharges & DTH packs
                  </p>
                </div>
              </div>
              <span className="text-[11px] font-bold px-2.5 py-1 bg-blue-50 text-blue-700 border border-blue-100 rounded-full">
                Prepaid & DTH
              </span>
            </div>
            <div className="overflow-hidden rounded-2xl border border-slate-200/70">
              <table className="w-full text-left border-collapse text-xs">
                <thead>
                  <tr className="bg-slate-900 text-white font-semibold">
                    <th className="py-3 px-4">Operator / Service Provider</th>
                    <th className="py-3 px-4 text-right">Commission Rate</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100 font-medium text-slate-700">
                  {mobileDthCharges.map((item, index) => (
                    <tr key={index} className="hover:bg-slate-50/80 transition-colors">
                      <td className="py-3 px-4 font-semibold text-slate-800">{item.provider}</td>
                      <td className="py-3 px-4 text-right font-mono font-bold text-emerald-700 text-sm">
                        {item.commission}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* AePS Settlement Charges */}
          <div className="bg-white rounded-3xl p-6 border border-slate-200/80 shadow-xs space-y-4">
            <div className="flex items-center justify-between pb-3 border-b border-slate-100">
              <div className="flex items-center gap-2.5">
                <div className="p-2.5 rounded-2xl bg-rose-50 text-rose-600 border border-rose-100/60">
                  <ArrowRightLeft className="w-4 h-4" />
                </div>
                <div>
                  <h2 className="text-base font-bold text-slate-800 leading-none">
                    AePS Settlement Charges
                  </h2>
                  <p className="text-[11px] text-slate-400 font-medium mt-1">
                    Standard bank charges to primary settlement accounts
                  </p>
                </div>
              </div>
              <span className="text-[11px] font-bold px-2.5 py-1 bg-rose-50 text-rose-700 border border-rose-100 rounded-full">
                Settlement
              </span>
            </div>
            <div className="overflow-hidden rounded-2xl border border-slate-200/70">
              <table className="w-full text-left border-collapse text-xs">
                <thead>
                  <tr className="bg-slate-900 text-white font-semibold">
                    <th className="py-3 px-4">Settlement Amount Slab</th>
                    <th className="py-3 px-4 text-right">Retailer Fee / Charge</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100 font-medium text-slate-700">
                  {settlementCharges.map((item, index) => (
                    <tr key={index} className="hover:bg-slate-50/80 transition-colors">
                      <td className="py-3 px-4 font-mono font-semibold text-slate-800">
                        {item.slab}
                      </td>
                      <td className="py-3 px-4 text-right font-mono font-bold text-rose-700 text-sm">
                        {item.rt}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Air Ticket */}
          <div className="bg-white rounded-3xl p-6 border border-slate-200/80 shadow-xs space-y-4">
            <div className="flex items-center justify-between pb-3 border-b border-slate-100">
              <div className="flex items-center gap-2.5">
                <div className="p-2.5 rounded-2xl bg-sky-50 text-sky-600 border border-sky-100/60">
                  <Plane className="w-4 h-4" />
                </div>
                <div>
                  <h2 className="text-base font-bold text-slate-800 leading-none">
                    Air Ticket
                  </h2>
                  <p className="text-[11px] text-slate-400 font-medium mt-1">
                    Retailer markup on flight bookings
                  </p>
                </div>
              </div>
              <span className="text-[11px] font-bold px-2.5 py-1 bg-sky-50 text-sky-700 border border-sky-100 rounded-full">
                Travel
              </span>
            </div>
            <div className="overflow-hidden rounded-2xl border border-slate-200/70">
              <table className="w-full text-left border-collapse text-xs">
                <thead>
                  <tr className="bg-slate-900 text-white font-semibold">
                    <th className="py-3 px-4">Booking Type</th>
                    <th className="py-3 px-4 text-right">Markup</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100 font-medium text-slate-700">
                  {airTicketCharges.map((item, index) => (
                    <tr key={index} className="hover:bg-slate-50/80 transition-colors">
                      <td className="py-3 px-4 font-semibold text-slate-800">{item.slab}</td>
                      <td className="py-3 px-4 text-right font-mono font-bold text-sky-700 text-sm">
                        {item.charge}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* STB — updated */}
          <div className="bg-white rounded-3xl p-6 border border-slate-200/80 shadow-xs space-y-4">
            <div className="flex items-center justify-between pb-3 border-b border-slate-100">
              <div className="flex items-center gap-2.5">
                <div className="p-2.5 rounded-2xl bg-violet-50 text-violet-600 border border-violet-100/60">
                  <Tv className="w-4 h-4" />
                </div>
                <div>
                  <h2 className="text-base font-bold text-slate-800 leading-none">
                    STB (Send to bank)
                  </h2>
                  <p className="text-[11px] text-slate-400 font-medium mt-1">
                    Flat charges below threshold, free above
                  </p>
                </div>
              </div>
              <span className="text-[11px] font-bold px-2.5 py-1 bg-violet-50 text-violet-700 border border-violet-100 rounded-full">
                Bank Transfer
              </span>
            </div>
            <div className="overflow-hidden rounded-2xl border border-slate-200/70">
              <table className="w-full text-left border-collapse text-xs">
                <thead>
                  <tr className="bg-slate-900 text-white font-semibold">
                    <th className="py-3 px-4">Amount Slab</th>
                    <th className="py-3 px-4 text-right">Charge</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100 font-medium text-slate-700">
                  {stbCharges.map((item, index) => (
                    <tr key={index} className="hover:bg-slate-50/80 transition-colors">
                      <td className="py-3 px-4 font-mono font-semibold text-slate-800">
                        {item.slab}
                      </td>
                      <td className="py-3 px-4 text-right font-mono font-bold text-violet-700 text-sm">
                        {item.charge}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* DMT */}
          <div className="bg-white rounded-3xl p-6 border border-slate-200/80 shadow-xs space-y-4">
            <div className="flex items-center justify-between pb-3 border-b border-slate-100">
              <div className="flex items-center gap-2.5">
                <div className="p-2.5 rounded-2xl bg-lime-50 text-lime-700 border border-lime-100/60">
                  <Send className="w-4 h-4" />
                </div>
                <div>
                  <h2 className="text-base font-bold text-slate-800 leading-none">
                    DMT (Domestic Money Transfer)
                  </h2>
                  <p className="text-[11px] text-slate-400 font-medium mt-1">
                    Percentage-based transfer charges
                  </p>
                </div>
              </div>
              <span className="text-[11px] font-bold px-2.5 py-1 bg-lime-50 text-lime-700 border border-lime-100 rounded-full">
                Money Transfer
              </span>
            </div>
            <div className="overflow-hidden rounded-2xl border border-slate-200/70">
              <table className="w-full text-left border-collapse text-xs">
                <thead>
                  <tr className="bg-slate-900 text-white font-semibold">
                    <th className="py-3 px-4">Amount Slab</th>
                    <th className="py-3 px-4 text-right">Charge</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100 font-medium text-slate-700">
                  {dmtCharges.map((item, index) => (
                    <tr key={index} className="hover:bg-slate-50/80 transition-colors">
                      <td className="py-3 px-4 font-mono font-semibold text-slate-800">
                        {item.slab}
                      </td>
                      <td className="py-3 px-4 text-right font-mono font-bold text-lime-700 text-sm">
                        {item.charge}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RateList;